module.exports = "<template> <img src=" + require("./logo_amadeus.gif") + " alt=Amadeus class=\"img-responsive pull-left\" style=height:2em> </template> ";